import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type { FamilyAccountSeatUsage } from '@backrs_ui/grow-ui/src/redux/family/family.types';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { InviteMembersForm } from './InviteMembersForm';

const {
  modules: {
    accountSettings: {
      family: {
        sections: {
          invites: { title, description },
        },
      },
    },
  },
} = appStrings;

type InviteFamilyMembersProps = Readonly<{
  seatUsage: FamilyAccountSeatUsage | null;
}>;

export const InviteFamilyMembers = ({ seatUsage }: InviteFamilyMembersProps) => {
  return (
    <Box sx={containerSx}>
      <Box>
        <Typography
          variant="text-sm-semibold"
          color={({ backrs }) => backrs.colors['Colors/Text/text-secondary']}
        >
          {title}
        </Typography>
        <Typography
          variant="text-sm-regular"
          color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
        >
          {description}
        </Typography>
      </Box>
      <InviteMembersForm availableSeats={seatUsage?.available ?? 0} />
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  width: '100%',
  marginTop: backrs.spacing['spacing-4xl'],
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  '@media (min-width: 700px)': {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    gap: backrs.spacing['spacing-4xl'],
  },
});
